import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";
import BDServiceCard from "@/pages/services/business-development/BDServiceCard";

const COMPANY_NAME = "NetBasis International";

const bdTitle = "Développement commercial";
const bdHeroOverlay = "Toujours votre activité à l'esprit !";
const bdHeroAlt = "Un homme d'affaires planifie stratégies et canaux de vente TIC pour entrer sur le marché DACH.";
const bdH1 = "Votre partenaire stratégique et opérationnel pour une entrée réussie sur le marché de la région DACH. Nous développons des stratégies de marché pragmatiques pour les entreprises étrangères du secteur des TIC et les mettons en œuvre avec succès à vos côtés sur le terrain.";
const bdIntro = "NetBasis International soutient l'intégralité des projets commerciaux de ses partenaires constructeurs, qu'il s'agisse de l'introduction de produits, solutions et services existants sur de nouveaux marchés internationaux ou du développement de nouveaux domaines d'activité et d'opportunités de marché. Nous générons et développons des stratégies commerciales pratiques et efficaces, concevons et fournissons les plans de mise en œuvre requis, et accompagnons nos partenaires tout au long de la phase d'exécution et, si souhaité, au-delà.";
const benefitsTitle = "Comment vous profitez de notre expertise en __développement commercial__ :";
const readMore = "En savoir plus";
const bottomClaim = "NetBasis International – drive to excellence with excellent drivers !";

const services = [
  {
    name: "Présence commerciale",
    image: "https://net-basis.net/Bilder/duesseldorf-media-harbor-rhine-tower-business-location.webp",
    description: "Présence et contact locaux : établissez une base fiable à Düsseldorf et développez votre activité sur le marché DACH, sans les coûts de structures administratives propres.",
    to: "/fr/services/developpement-commercial/presence-commerciale",
  },
  {
    name: "Offre complète",
    image: "https://net-basis.net/Bilder/ict-full-service-business-development-management.webp",
    description: "Votre bras droit dans la région DACH : nous gérons l'ensemble de vos activités de A à Z. Gardez l'esprit libre pour votre marché d'origine.",
    to: "/fr/services/developpement-commercial/offre-complete",
  },
  {
    name: "Conseil",
    image: "https://net-basis.net/Bilder/ict-market-entry-business-strategy-consulting.webp",
    description: "Conseil stratégique : nous évaluons votre potentiel sur le marché DACH et vous guidons de l'analyse initiale à la mise en œuvre de vos objectifs.",
    to: "/fr/services/developpement-commercial/conseil",
  },
  {
    name: "Gestion de produits",
    image: "https://net-basis.net/Bilder/ict-product-management-market-adaptation-modular-development.webp",
    description: "Succès sur le marché DACH : nous adaptons vos produits TIC aux normes, aux lois et aux marchés locaux.",
    to: "/fr/services/developpement-commercial/gestion-de-produits",
  },
  {
    name: "Gestion de projets",
    image: "https://net-basis.net/Bilder/project-management-planning-control-dach-market-entry.webp",
    description: "Gestion de projet efficace : nous pilotons vos projets DACH en maîtrisant les risques, les délais et les budgets.",
    to: "/fr/services/developpement-commercial/gestion-de-projets",
  },
  {
    name: "Analyses de marché",
    image: "https://net-basis.net/Bilder/market-analysis-business-intelligence-dach-market-entry.webp",
    description: "Données de marché précises : nous analysons la taille du marché, les tendances et la concurrence locale.",
    to: "/fr/services/developpement-commercial/analyses-de-marche",
  },
  {
    name: "Stratégies d'entrée sur le marché",
    image: "https://net-basis.net/Bilder/dach-market-entry-strategy-target-market-positioning.webp",
    description: "Expansion stratégique : nous concevons vos options d'entrée et planifions votre succès durable sur le marché DACH.",
    to: "/fr/services/developpement-commercial/strategies-entree-marche",
  },
  {
    name: "Gestion des importations",
    image: "https://net-basis.net/Bilder/import-management-customs-clearance-dach-distribution.webp",
    description: "Votre service d'importation local : nous gérons votre logistique DACH de manière globale, du dédouanement conforme à la livraison ponctuelle.",
    to: "/fr/services/developpement-commercial/gestion-des-importations",
  },
  {
    name: "Commerce international",
    image: "https://net-basis.net/Bilder/international-trade-dach-local-expertise.webp",
    description: "Commerce international sécurisé : nous gérons vos structures de prix, contrats et licences dans la région DACH pour garantir une activité conforme et rentable.",
    to: "/fr/services/developpement-commercial/commerce-international",
  },
  {
    name: "Support technique",
    image: "https://net-basis.net/Bilder/technical-support-dach-customer-service.webp",
    description: "Assistance technique rapide : nous assurons un support TIC qualifié, une télémaintenance fiable et une aide sur site pour vos clients dans la région DACH.",
    to: "/fr/services/developpement-commercial/support-technique",
  },
];

const benefits = [
  "Identification et développement de canaux de distribution optimaux et de réseaux de partenaires",
  "Conception de stratégies marketing et publicitaires ciblées",
  "Recommandations fondées pour les modifications de produits ou les adaptations au marché nécessaires",
  "Initiation d'opportunités de développement de produits durables",
  "Préparation structurée des opérations commerciales locales et de la logistique",
  "Planification précise de la réalisation des stratégies commerciales convenues",
  "Analyse et évaluation des opportunités potentielles de transferts de technologies, de coopérations sous licence, de joint-ventures ou de fusions",
];

export default function BusinessDevelopmentFrPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="Développement Commercial | NetBasis International"
        description="Développement stratégique du marché et soutien opérationnel des ventes pour votre succès durable dans l’espace germanophone."
        ogUrl="https://net-basis.net/fr/services/developpement-commercial"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        <section className="w-full bg-white py-4 md:py-6 lg:py-8">
          <div className="w-full max-w-[1100px] mx-auto">
            <div className="relative w-full h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden">
              <img loading="lazy"
                src="https://net-basis.net/Bilder/ict-business-development-strategy-dach-market-entry.webp"
                alt={bdHeroAlt}
                title={bdTitle}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
              <div className="absolute inset-0 z-20 flex items-start justify-end md:justify-start pl-10 md:pl-[30%] lg:pl-[15%] pr-6 md:pr-10 pointer-events-none">
                <p
                  className="w-full text-3xl md:text-4xl lg:text-5xl font-normal text-white drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)] text-right mt-2 md:mt-8 lg:mt-12 max-w-[85%] md:max-w-none animate-[bdTextSlide_12s_ease-in-out_infinite]"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                >
                  {bdHeroOverlay}
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {bdTitle}
            </h2>
            <h1 className="text-foreground-950 font-semibold text-sm md:text-base leading-relaxed mb-4">
              {bdH1}
            </h1>
            <p className="text-foreground-950 leading-relaxed text-sm md:text-base">
              <strong className="text-primary-600">{COMPANY_NAME}</strong>{" "}
              {bdIntro.replace(COMPANY_NAME, "").trim()}
            </p>
          </div>
        </section>

        <section className="py-5 md:py-7 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col gap-3 md:gap-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
                {services.slice(0, 3).map((svc, idx) => (
                  <BDServiceCard key={idx} name={svc.name} image={svc.image} description={svc.description} to={svc.to} readMore={readMore} />
                ))}
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
                {services.slice(3, 7).map((svc, idx) => (
                  <BDServiceCard key={idx} name={svc.name} image={svc.image} description={svc.description} to={svc.to} readMore={readMore} />
                ))}
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
                {services.slice(7, 10).map((svc, idx) => (
                  <BDServiceCard key={idx} name={svc.name} image={svc.image} description={svc.description} to={svc.to} readMore={readMore} />
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {benefitsTitle.split('__').map((part, i) =>
                i % 2 === 1 ? <em key={i}>{part}</em> : part
              )}
            </h2>
            <div className="space-y-1.5 md:space-y-2 text-foreground-950 leading-relaxed text-sm md:text-base">
              {benefits.map((benefit, idx) => (
                <div key={idx} className="flex items-start gap-2 md:gap-3">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-primary-600 text-base md:text-lg"></i>
                  </div>
                  <p>{benefit}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <p className="font-heading text-lg md:text-xl font-bold text-primary-600">
              {bottomClaim}
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}